import React, { Component } from 'react';
import { Container, Row, Col, Table, Button, Badge } from 'react-bootstrap';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import formatMoney from '../../utils/formatMoney';
import { connect } from 'react-redux';
import moment from 'moment';

const select = state => {
  return {
    token: state.auth.token
  };
};

class ConnectedFoundationPaymentsComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      requestedPayments: [],
      receivedPayments: []
    };
  }

  async componentDidMount() {

    const { token } = this.props;
    
    const fetchRequestedPayments = fetch(`${apiUrl}/admin/foundations/payments?requested=true&token=${token}`);
    const fetchReceivedPayments = fetch(`${apiUrl}/admin/foundations/payments?token=${token}`);

    const respRequestedPayments = await fetchRequestedPayments;
    const respReceivedPayments = await fetchReceivedPayments;

    const dataRequestedPayments = await respRequestedPayments.json();
    const dataReceivedPayments = await respReceivedPayments.json();

    if (dataRequestedPayments.success && dataReceivedPayments.success) {
      this.setState({
        requestedPayments: dataRequestedPayments.payments,
        receivedPayments: dataReceivedPayments.payments
      });
    }

    this.setState({ isLoading: false });

  }

  render() {

    const { requestedPayments, receivedPayments, isLoading } = this.state;
    const { history } = this.props;

    if (isLoading) return (<AppSpinner />);

    return (
      <div className="table-info-component foundation-payments-component">
        <Container>
          <Row>
            <Col xs={12}>
              <h2 className="header">Desembolsos</h2>
            </Col>

            <Col xs={12}>
              <h4 className="title">Desembolsos solicitados</h4>

              {
                !requestedPayments.length ? <p>No hay desembolsos solicitados.</p> :
              
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Fundación</th>
                      <th>Programa</th>
                      <th>Valor</th>
                      <th>Fecha de solicitud</th>
                      <th>Tipo</th>
                      <th>Ver más</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      requestedPayments.map((payment, index) =>
                        <tr key={payment._id}>
                          <td>{index + 1}</td>
                          <td>{payment.foundationName}</td>
                          <td>{payment.programName}</td>
                          <td>${formatMoney(payment.amount)}</td>
                          <td>{moment(payment.dateRequested).format('YYYY-MM-DD')}</td>
                          <td>
                            <Badge variant={payment.type === 'PARCIAL' ? 'primary' : 'success'}>
                              {payment.type.toLowerCase()}
                            </Badge>
                          </td>
                          <td>
                            <Button
                              variant="info"
                              size="sm"
                              onClick={() => {
                                history.push(`/fundaciones/desembolsos/${payment._id}`);
                              }}
                            >
                              Ver más
                            </Button>
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
              }
              <hr />
            </Col>

            <Col xs={12}>
              <h4 className="title">Desembolsos</h4>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Fundación</th>
                    <th>Programa</th>
                    <th>Valor</th>
                    <th>Fecha de desembolso</th>
                    <th>Tipo</th>
                    <th>Comprobante</th>
                    <th>Editar</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    receivedPayments.map((payment, index) =>
                      <tr key={payment._id}>
                        <td>{index + 1}</td>
                        <td>{payment.foundationName}</td>
                        <td>{payment.programName}</td>
                        <td>${formatMoney(payment.amount)}</td>
                        <td>{payment.datePayed ? payment.datePayed.split('T')[0] : ''}</td>
                        <td>
                          <Badge variant={payment.type === 'PARCIAL' ? 'primary' : 'success'}>
                            {payment.type.toLowerCase()}
                          </Badge>
                        </td>
                        <td>
                          <a href={payment.voucherPhoto} target="_blank" rel="noopener noreferrer">
                            Comprobante
                          </a>
                        </td>
                        <td>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => {
                              history.push(`/fundaciones/desembolsos/${payment._id}`);
                            }}
                          >
                            Editar
                          </Button>
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Col>

          </Row>
        </Container>
      </div>
    );
  }
}

const FoundationPaymentsComponent = connect(select)(ConnectedFoundationPaymentsComponent);

export default FoundationPaymentsComponent;
